import { connect } from 'react-redux';
import { setAvailableMics, setMicSelected, setLangSelected } from '../../actions';
import { createNewConversation } from '../../actions/conversation';
import { setMacAudioSetup, setUrlToOpenAfterStartingConvo } from '../../actions/session';
import SetupAudio from './SetupAudio';

export default connect(null, {
  setMicSelected,
  setAvailableMics,
  createNewConversation,
  setMacAudioSetup,
  setUrlToOpenAfterStartingConvo,
  setLangSelected,
})(SetupAudio);
